<div class="top-band">
  <div class="container">
    <div class="heading">
      <a *ngIf="route; else noRoute" [routerLink]="route" [fragment]="fragment"
        ><img src="assets/images/icons/arrow-left.svg" class="arrow-left" *ngIf="text.length" /> {{ text }}</a
      >
      <ng-template #noRoute>
        <a *ngIf="external; else noExternal" (click)="navigate()" href="javascript:void(0)"
          ><img src="assets/images/icons/arrow-left.svg" class="arrow-left" *ngIf="text.length" /> {{ text }}</a
        >
      </ng-template>
      <ng-template #noExternal> {{ text }}&nbsp; </ng-template>
    </div>
  </div>
  <div class="grey-swoosh"></div>
</div>
